import { Icon } from "@mindlercare/ui-web";
import { styled, useTheme } from "styled-components";
import { Typography } from "components/typography";

type NumberHighlightProps = {
  title: string;
  value: number;
  difference?: {
    changeAmount: number;
    coloring: "positive" | "negative";
    text: string;
  };
};

const NumberHighlight = ({
  title,
  value,
  difference,
}: NumberHighlightProps) => {
  const theme = useTheme();
  const renderDifference = difference && difference.changeAmount !== 0;

  const plusOrMinus = (difference?.changeAmount ?? 0) > 0 ? "+" : "";
  const differenceColorName =
    difference?.coloring === "positive" ? "SUCCESS" : "ERROR";
  const differenceColor = theme.COLORS[differenceColorName];

  return (
    <NumberHighlightWrapper>
      <Typography variant="h3">{title}</Typography>
      <Typography variant="h1">{value}</Typography>
      {renderDifference && (
        <Difference>
          {difference.changeAmount > 0 ? (
            <Icon.TrendingUp fill={differenceColor} />
          ) : (
            <Icon.TrendingDown fill={differenceColor} />
          )}
          <Typography variant="body" color={differenceColorName}>
            {plusOrMinus}
            {difference.changeAmount} {difference.text}
          </Typography>
        </Difference>
      )}
    </NumberHighlightWrapper>
  );
};

const Difference = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.SPACING.XS};
`;

const NumberHighlightWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export default NumberHighlight;
